import { getSourceProtocol } from "./utils/protocol";
import { cloneDeep } from "lodash-es";
import { METHOD_TYPES } from "../stateCommon/consts";
import { autoCodeMode, getCodeGenerateMode } from "./utils/codeGenerateModes";
// const defaultConfig = { codeKey: 'code', msgKey: 'message' };
export class MethodGenerateContext {
  constructor(options) {
    var _options$collection$s;
    this.options = options;
    this.codeMode = '';
    Object.assign(this, options);
    this.extraConfig = cloneDeep(options.extraConfig);
    this.protocol = getSourceProtocol(this.extraConfig, !this.isFreeType, options.collection);
    const codeMode = getCodeGenerateMode((_options$collection$s = options.collection.settings) === null || _options$collection$s === void 0 ? void 0 : _options$collection$s.codeMode).value;
    this.codeMode = codeMode;
  }
  get isHttp() {
    return this.isFreeType;
  }
  get isFreeType() {
    const {
      type
    } = this.collection;
    return type === 'http' || type === 'sql' || type === 'frontEndHttp';
  }
  get isSql() {
    return this.collection.type === 'sql';
  }
  get isFormType() {
    var _this$extraConfig;
    if (this.methodType) {
      return this.methodType !== METHOD_TYPES.code;
    }
    return ((_this$extraConfig = this.extraConfig) === null || _this$extraConfig === void 0 ? void 0 : _this$extraConfig.defaultMethodType) !== METHOD_TYPES.code;
  }
  get codeKey() {
    // if (this.isFreeType) {
    //   return this.extraConfig.codeKey || defaultConfig.codeKey;
    // }
    // return defaultConfig.codeKey;
    return this.protocol.CODE;
  }
  get msgKey() {
    // if (this.isFreeType) {
    //   return this.extraConfig.msgKey || defaultConfig.msgKey;
    // }
    // return defaultConfig.msgKey;
    return this.protocol.MESSAGE;
  }
  get entityDataPath() {
    return this.protocol.ENTITY_DATA;
  }
  get getCodeString() {
    return `body.${this.protocol.CODE}`;
  }
  get getMsgString() {
    return `body.${this.protocol.MESSAGE}`;
  }
  get getEntityString() {
    return `body.${this.protocol.ENTITY_DATA}`;
  }
  /**
   * 不走强协议，使用cgiInfo.extra 进行代码生成， 这时候生成的方法是不支持可视化的
   */
  get isAuto() {
    return this.codeMode === autoCodeMode.value;
  }
  getProtocolPath(cgiName, key) {
    var _this$collection$cgiI, _cgiInfo$extra;
    if (!this.isFreeType || !this.isAuto) {
      const value = this.protocol[key];
      return withDot(value);
    }
    const cgiInfo = (_this$collection$cgiI = this.collection.cgiInfo) === null || _this$collection$cgiI === void 0 ? void 0 : _this$collection$cgiI[cgiName];
    const value = cgiInfo === null || cgiInfo === void 0 || (_cgiInfo$extra = cgiInfo.extra) === null || _cgiInfo$extra === void 0 ? void 0 : _cgiInfo$extra[key];
    const res = value === undefined || value === null ? this.protocol[key] : value;
    return withDot(res);
  }
  getStringOfCodeMessage(cgiName) {
    const code = this.getProtocolPath(cgiName, 'CODE');
    const message = this.getProtocolPath(cgiName, 'MESSAGE');
    return {
      codeString: `body${code}`,
      messageString: `body${message}`
    };
  }
}
function withDot(v) {
  const value = String(v);
  return value === '' ? value : `${value.startsWith('.') ? '' : '.'}${value}`;
}
//# sourceMappingURL=MethodGenerateContext.js.map
